import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import {
  getUser,
  getCustomerUsers,
  getProjectDetails,
  getProjectContent,
  getLoadingProjectInitialTree,
  getProjectTree,
  getDatasetReaders,
  getDatasetFileReaders,
  getLoadingDatasetReaders,
  getDatasetWriters,
  getDatasetDedicatedWriters,
  getLoadingDatasetWriters,
  getLoadingApplications,
  getApplications,
  getCoordinateSystemsLoading,
  getSelectedCoordinateSystems,
  getSearchCoordinateSystemsById,
  getProjectContentPagination,
  getProjectContentRowsPerPage,
  getProjectContentNamePrefix,
  getProjectContentSortBy,
  getProjectContentSortOrder,
  getTenantFeatures
} from '../state'

import ProjectContent from '../components/ProjectContent'

const mapStateToProps = createSelector(
  [
    getUser,
    getCustomerUsers,
    getProjectDetails,
    getProjectContent,
    getLoadingProjectInitialTree,
    getProjectTree,
    getDatasetReaders,
    getDatasetFileReaders,
    getLoadingDatasetReaders,
    getDatasetWriters,
    getDatasetDedicatedWriters,
    getLoadingDatasetWriters,
    getLoadingApplications,
    getApplications,
    getCoordinateSystemsLoading,
    getSelectedCoordinateSystems,
    getSearchCoordinateSystemsById,
    getProjectContentPagination,
    getProjectContentRowsPerPage,
    getProjectContentNamePrefix,
    getProjectContentSortBy,
    getProjectContentSortOrder,
    getTenantFeatures
  ],
  (
    user,
    customerUsers,
    project,
    projectContent,
    loadingInitialTree,
    projectTree,
    datasetReaders,
    datasetFileReaders,
    showDatasetReadersLoader,
    datasetWriters,
    dedicatedWriters,
    showDatasetWritersLoader,
    loadingApps,
    apps,
    loadingCoordinateSystems,
    selectedCoordinateSystems,
    searchCoordinateSystemsById,
    page,
    rowsPerPage,
    namePrefix,
    sortBy,
    sortOrder,
    features
  ) => ({
    user,
    customerUsers,
    project,
    projectContent,
    loadingInitialTree,
    projectTree,
    datasetReaders,
    datasetFileReaders,
    showDatasetReadersLoader,
    datasetWriters,
    dedicatedWriters,
    showDatasetWritersLoader,
    loadingApps,
    apps,
    loadingCoordinateSystems,
    selectedCoordinateSystems,
    searchCoordinateSystemsById,
    page,
    rowsPerPage,
    namePrefix,
    sortBy,
    sortOrder,
    features
  })
)

export default connect(mapStateToProps)(ProjectContent as any)
